import React, {useState} from 'react';
import { useStyles } from "./style";
import Form from 'components/Form/FormTwoColumns';
import Alert from 'react-s-alert';
import {Container, Grid} from '@material-ui/core/';
//COMPONENTS
import ApiServices from 'services/ApiServices';
import UserInformation from './UserInformation'
import PoliticasCambioContraseña from './PoliticasCambioContraseña'
//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {showMessageWarningSimple, showMessageErrorSimple, showMessageSuccessSimple} from 'services/SweetAlert'

function FormularioCambiarContraseña(props) {
    const classes = useStyles();
    const [controller, setController] = useState('user');
    const [apiErrors,setApiErrors] = React.useState([]);
    const [elements, setElements] = React.useState({
        password: { idelement: "password",  value:'', label: "Contraseña", pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Campo requerido'], isError:false, elementType:'password' },
        repassword: { idelement: "repassword",  value:'', label: "Repetir Contraseña", pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Campo requerido'], isError:false, elementType:'password' },
    });

    const CambiarContraseña = async () =>{
        let updateElement  = {id: props.currentUser.id, password: elements.password.value, repassword: elements.repassword.value};
        if(elements.password.value === elements.repassword.value){
            try{
                const hasPermission = await ApiServices.userSecurity.hasPermission(controller,'changePassword');    
                if (hasPermission.error){
                    showMessageWarningSimple('¡Oops!','No tiene permisos para realizar esta acción.')
                }else{
                    const changePassword =  await ApiServices.userSecurity.changePassword(updateElement);
                    if(changePassword.error!==null){
                        showMessageErrorSimple('¡Oops!','Error al realizar la petición de cambio de contraseña.')
                    }else{
                        showMessageSuccessSimple('¡BIEN!','Contraseña actualizada correctamente.')
                        elements.password.value="";
                        elements.repassword.value="";
                        setElements({ ...elements });                        
                    }   
                }
            }catch(exception){
                (exception.status===404) ? Alert.error("Falla del sistema"): Alert.error("Intente de nuevo ");
            }            
        }else{
            showMessageWarningSimple('¡Oops!','Contraseñas no coinciden, intente de nuevo.')
        }        
    }

    const [buttonList,setButtonList]= React.useState({
        "register":{"label":"Cambiar Contraseña","callback":CambiarContraseña,"loading":false,"color":"#fff", "icon": "save", "width":230 ,"background":"#1C4E78"},
    });

    return (
        <div>
            <br/>
            <Container maxWidth="md">        
                <Grid container >
                    <div className={classes.colorComponente} style={{width: '100%', position: 'relative', overflow: 'auto', border: '1px solid  #cccccc', borderRadius: '20px', marginBottom:10,}} >
                        <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                            <UserInformation DatosUsuario={props.currentUser}/>
                        </Grid>
                        <div className={classes.lineaDegradadaBottom}></div>
                    </div>
                    <div className={classes.colorComponente}style={{width: '100%', position: 'relative', overflow: 'auto', border: '1px solid  #cccccc', borderRadius: '20px', marginBottom:10,}} >
                        <Grid item xs={12} container direction="row" justify="center" alignItems="center" className={classes.centrarBoton}>
                        <PoliticasCambioContraseña/>
                            <Form   
                                elements= {elements} 
                                buttonList={buttonList}
                                apiErrors={apiErrors} 
                            />
                        </Grid>
                        <div className={classes.lineaDegradadaBottom}></div>
                    </div>
                </Grid>
            </Container>
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(FormularioCambiarContraseña);